import { useTranslation } from "react-i18next";
import { ShieldAlert, Volume2, ExternalLink, Radar } from "lucide-react";
import { Button } from "../ui/button";
import { speakAdvisory } from "../../utils/alertSound";

export default function SafeRouteAdvisoryCard({ data, liveOn, onToggleLive }) {
  const { t } = useTranslation();
  const speak = () => {
    try { speakAdvisory(data.advisory); }
    catch { /* speech synthesis is best-effort; ignore browser refusals */ }
  };
  return (
    <div className="bg-gray-50 border border-gray-200 rounded-sm p-2.5" data-testid="safe-route-advisory">
      <p className="text-xs text-gray-800 font-body leading-snug">
        <ShieldAlert className="w-3.5 h-3.5 inline mr-1 text-amber-600" />
        {data.advisory}
      </p>
      <div className="flex gap-2 mt-2 flex-wrap">
        <Button
          variant="ghost"
          size="sm"
          onClick={speak}
          className="h-6 text-[10px] rounded-sm px-2"
          data-testid="safe-route-speak"
        >
          <Volume2 className="w-3 h-3 mr-1" /> {t("safe_route.speak")}
        </Button>
        <Button
          variant={liveOn ? "default" : "ghost"}
          size="sm"
          onClick={onToggleLive}
          className={`h-6 text-[10px] rounded-sm px-2 ${liveOn ? "bg-emerald-600 hover:bg-emerald-700 text-white" : ""}`}
          data-testid="safe-route-live-toggle"
        >
          <Radar className="w-3 h-3 mr-1" /> {liveOn ? t("safe_route.live_on") : t("safe_route.live_off")}
        </Button>
        <a
          href={`https://www.google.com/maps/dir/?api=1&origin=${data.origin.latitude},${data.origin.longitude}&destination=${encodeURIComponent(data.destination)}&travelmode=driving`}
          target="_blank"
          rel="noreferrer"
          data-testid="safe-route-open-maps"
          className="inline-flex items-center h-6 text-[10px] font-body text-gray-700 hover:text-black px-1"
        >
          <ExternalLink className="w-3 h-3 mr-1" /> {t("safe_route.open_in_maps")}
        </a>
      </div>
    </div>
  );
}
